import { HttpParams } from '@angular/common/http';


// TODO: LOG: find better per request API to manipulate retry strategy
export class RetryCountHttpParams extends HttpParams {

    static readonly paramName: string = '__srp_logging__requestRetryCount';

    constructor(retryCount: number) {
        super({ fromObject: { [RetryCountHttpParams.paramName]: retryCount } });
    }
}